"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerRequestApi = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class SignerRequestApi {
    static createSignerRequest(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request",
            body: requestBody,
            mediaType: "application/json",
        });
    }
    static getSignerRequestStatus(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "GET",
            url: "/api/signer-request/{id}/status",
            path: {
                id: id,
            },
        });
    }
    static approveSignerRequest(id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request/{id}/approve",
            path: {
                id: id,
            },
            body: requestBody,
            mediaType: "application/json",
        });
    }
    static rejectSignerRequest(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request/{id}/reject",
            path: {
                id: id,
            },
        });
    }
    static getSignerRequest(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "GET",
            url: "/api/signer-request/{id}",
            path: {
                id: id,
            },
        });
    }
    static createSignMessageRequest(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request/message",
            body: requestBody,
            mediaType: "application/json",
        });
    }
    static getSignMessageRequest(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "GET",
            url: "/api/signer-request/message/{id}",
            path: {
                id: id,
            },
        });
    }
    static signMessageRequest(id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request/message/{id}/sign",
            path: {
                id: id,
            },
            body: requestBody,
            mediaType: "application/json",
        });
    }
    static rejectMessageRequest(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: "POST",
            url: "/api/signer-request/message/{id}/reject",
            path: {
                id: id,
            },
        });
    }
}
exports.SignerRequestApi = SignerRequestApi;
